import { cn } from '@/lib/cn';
import { tagDef, type TagKind } from '@/lib/tags';

/**
 * Renderiza tags como chips coloridos. Por padrão mostra só os buckets de
 * classificação (a info nova do enriquecimento); as tags organizacionais de
 * lote são escondidas na lista pra não poluir (o usuário já filtra por elas).
 */
export function TagChips({
  tags,
  show = ['bucket'],
  size = 'xs',
  className,
}: {
  tags?: string[];
  show?: TagKind[];
  size?: 'xs' | 'sm';
  className?: string;
}) {
  if (!tags || tags.length === 0) return null;
  const visible = tags.map(tagDef).filter((d) => show.includes(d.kind));
  if (visible.length === 0) return null;

  const sizeCls = size === 'sm' ? 'text-[11px] px-1.5 py-0.5' : 'text-[10px] px-1.5 py-0';

  return (
    <span className={cn('inline-flex flex-wrap items-center gap-1', className)}>
      {visible.map((d) => (
        <span
          key={d.slug}
          className={cn(
            'inline-flex items-center rounded border leading-none lowercase tracking-tight',
            d.tone,
            sizeCls,
          )}
        >
          {d.label}
        </span>
      ))}
    </span>
  );
}
